import { Box } from '@material-ui/core';
import { formatDateTimeReadable } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export const ErrorMessageAdditionalDetails = () => {
  return (
    <Box mt={'20px'} mb={'8px'}>
      {/* <CustomDivider margin={'18px'} /> */}
      <Font variant={'body2'} style={{ wordBreak: 'break-all' }}>
        <strong>
          <Text tId={'DATE'} />
        </strong>
        {': '}
        {formatDateTimeReadable(new Date())}
      </Font>
      <br />
      <Font variant={'body2'} style={{ wordBreak: 'break-all' }}>
        <strong>{'URL'}</strong>
        {': '}
        {window.location.href}
      </Font>
    </Box>
  );
};
